import { render, staticRenderFns } from "./PhotoStationPrimary.vue?vue&type=template&id=34a0336b&"
import script from "./PhotoStationPrimary.vue?vue&type=script&lang=js&"
export * from "./PhotoStationPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports